import { useQuery } from 'data-fetching-client';
import { GET_ACTIVE_TRIALS } from 'pricing-pages-api/trials/queries';
export const useIsInActiveTrial = () => {
  const {
    data,
    loading
  } = useQuery(GET_ACTIVE_TRIALS);
  if (loading) {
    return undefined;
  }
  const activeTrials = data === null || data === void 0 ? void 0 : data.activeTrials;
  return activeTrials ? activeTrials.length > 0 : false;
};